<template>
  <sidenav :orientation="orientation" :class="curClasses">

    <!-- Inner -->
    <div class="sidenav-inner" :class="{ 'py-1': orientation !== 'horizontal' }">

       <sidenav-router-link v-if="false" icon="ion ion-md-cube" to="/home" :exact="true">Home</sidenav-router-link>

       <sidenav-menu v-if="hasMenuPermission(['Admission'])" icon="ion ion-md-cube" :active="isMenuActive('/student')" :open="isMenuOpen('/student')">
          <template slot="link-text">Student</template>
          <sidenav-router-link v-if="hasPermission('Admission')" to="/student/admission">Admission</sidenav-router-link>
        </sidenav-menu>

        <sidenav-menu v-if="hasMenuPermission(['Topic','Question','Exam','Assign','MyExam'])" icon="ion ion-md-cube" :active="isMenuActive('/exam')" :open="isMenuOpen('/exam')">
          <template slot="link-text">Exam</template>
          <sidenav-router-link v-if="hasPermission('Topic')" to="/exam/topic">Manage Topic</sidenav-router-link>
          <sidenav-router-link v-if="hasPermission('Question')" to="/exam/question">Manage Question</sidenav-router-link>
          <sidenav-router-link v-if="hasPermission('Exam')" to="/exam/exam">Manage Exam</sidenav-router-link>
          <sidenav-router-link v-if="hasPermission('Assign')" to="/exam/assign">Assign Exam</sidenav-router-link>
          <sidenav-router-link v-if="hasPermission('MyExam')" to="/exam/myexam">My Exam</sidenav-router-link>
        </sidenav-menu>

        <sidenav-menu v-if="hasMenuPermission(['Class','Section','Subject','Gender'])" icon="ion ion-md-cube" :active="isMenuActive('/common')" :open="isMenuOpen('/common')">
          <template slot="link-text">Common</template>
          <sidenav-router-link v-if="hasPermission('Class')" to="/common/class">Class</sidenav-router-link>
          <sidenav-router-link v-if="hasPermission('Section')" to="/common/section">Section</sidenav-router-link>
          <sidenav-router-link v-if="hasPermission('Subject')" to="/common/subject">Subject</sidenav-router-link>
          <sidenav-router-link v-if="hasPermission('Gender')" to="/common/gender">Gender</sidenav-router-link>
        </sidenav-menu>

        <sidenav-menu v-if="hasMenuPermission(['User','Role','Permission'])" icon="ion d-block ion-ios-lock" :active="isMenuActive('/security')" :open="isMenuOpen('/security')">
          <template slot="link-text">Security</template>
          <sidenav-router-link v-if="hasPermission('User')" to="/security/user">User</sidenav-router-link>
          <sidenav-router-link v-if="hasPermission('Role')" to="/security/role">Role</sidenav-router-link>
          <sidenav-router-link v-if="hasPermission('Permission')" to="/security/permission">Permission</sidenav-router-link>
          <!-- <sidenav-router-link to="/security/special-permission">Special Permission</sidenav-router-link> -->
        </sidenav-menu>

          <sidenav-menu v-if="hasMenuPermission(['General','Message'])" icon="ion d-block ion-ios-lock" :active="isMenuActive('/setting')" :open="isMenuOpen('/setting')">
          <template slot="link-text">Setting</template>
          <sidenav-router-link v-if="hasPermission('General')" to="/setting/general">General</sidenav-router-link>
          <sidenav-router-link v-if="hasPermission('Message')" to="/setting/message">Message</sidenav-router-link>
          </sidenav-menu>
    </div>
  </sidenav>
</template>

<script>
import { Sidenav, SidenavLink, SidenavRouterLink, SidenavMenu, SidenavHeader, SidenavBlock, SidenavDivider } from '@/vendor/libs/sidenav'

export default {
  name: 'app-layout-sidenav',
  components: {
    Sidenav,
    // eslint-disable-next-line vue/no-unused-components
    SidenavLink,
    SidenavRouterLink,
    SidenavMenu,
    // eslint-disable-next-line vue/no-unused-components
    SidenavHeader,
    // eslint-disable-next-line vue/no-unused-components
    SidenavBlock,
    // eslint-disable-next-line vue/no-unused-components
    SidenavDivider
  },

  props: {
    orientation: {
      type: String,
      default: 'vertical'
    }
  },
  data: () => ({
    permission: []
  }),
  created () {
    var permission = localStorage.getItem('permission')
    this.permission = JSON.parse(permission)
  },
  computed: {
    curClasses () {
      let bg = this.layoutSidenavBg

      if (this.orientation === 'horizontal' && (bg.indexOf(' sidenav-dark') !== -1 || bg.indexOf(' sidenav-light') !== -1)) {
        bg = bg
          .replace(' sidenav-dark', '')
          .replace(' sidenav-light', '')
          .replace('-darker', '')
          .replace('-dark', '')
      }

      return `bg-${bg} ` + (
        this.orientation !== 'horizontal'
          ? 'layout-sidenav'
          : 'layout-sidenav-horizontal container-p-x flex-grow-0'
      )
    }
  },

  methods: {
    hasPermission (formName) {
      var permission = this.permission.some(o => o.formName === formName)
      return permission
    },
    hasMenuPermission (forms) {
      var result = false
      for (let i = 0; i < this.permission.length; i++) {
        const formName = this.permission[i].formName
        forms.forEach(el => {
          if (formName.includes(el)) {
            result = true
          }
        })
      }
      return result
    },
    isMenuActive (url) {
      return this.$route.path.indexOf(url) === 0
    },

    isMenuOpen (url) {
      return this.$route.path.indexOf(url) === 0 && this.orientation !== 'horizontal'
    },

    toggleSidenav () {
      this.layoutHelpers.toggleCollapsed()
    }
  }
}
</script>
